import {
  InfoBadge,
  type InfoBadgeProps,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { useAuth } from "../../../hooks/useAuth";

export type UserInfoBadgeProps = Omit<InfoBadgeProps, "slotProps"> & {
  slotProps?: InfoBadgeProps["slotProps"];
  photoUser?: {
    has_photo?: boolean;
    id?: number;
    photo_url?: string | null;
  } | null;
};

export const UserInfoBadge: React.FC<UserInfoBadgeProps> = ({
  slotProps,
  photoUser,
  ...props
}) => {
  const { user } = useAuth();
  const photoUrl =
    user?.equinor && photoUser?.has_photo
      ? (photoUser.photo_url ?? undefined)
      : undefined;

  return (
    <InfoBadge
      {...props}
      slotProps={{
        ...slotProps,
        avatar: {
          ...slotProps?.avatar,
          ...(props.avatarType !== false
            ? {
                alt: slotProps?.avatar?.alt ?? props.info ?? props.subInfo,
                src: photoUrl,
              }
            : {}),
        },
      }}
    />
  );
};
